import Apis from 'constants/api';
import request from 'utils/http';

import { startLoading, stopLoading } from 'service/loader/action';

import actionTypes from './actionType';

export const getBlockReconRoutes = () => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.configuration.appRoutes)
        .then(({ data: { data } }) => {
            dispatch({
                type: actionTypes.GET_APPLICATION_ROUTES_SUCCESS,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((err) => {
            dispatch({
                type: actionTypes.GET_APPLICATION_ROUTES_SUCCESS,
                payload: [],
            });
            dispatch(stopLoading());
        });
};

export const enableRefDataRoutes = () => ({
    type: actionTypes.SET_BLOCK_REF_DATA_ROUTES,
});

export const enableReconRoutes = () => ({
    type: actionTypes.SET_BLOCK_RECON_ROUTES,
});


export const changeLayout = (layout) => ({
    type: actionTypes.CHANGE_LAYOUT,
    payload: layout,
});

export const changeLayoutWidth = (width) => ({
    type: actionTypes.CHANGE_LAYOUT_WIDTH,
    payload: width,
});

export const changeSidebarTheme = (theme) => ({
    type: actionTypes.CHANGE_SIDEBAR_THEME,
    payload: theme,
});

export const changeSidebarType = (sidebarType) => ({
    type: actionTypes.CHANGE_SIDEBAR_TYPE,
    payload: sidebarType,
});

export const toggleRightSidebar = () => ({
    type: actionTypes.TOGGLE_RIGHT_SIDEBAR,
    payload: null,
});

export const showRightSidebar = () => ({
    type: actionTypes.SHOW_RIGHT_SIDEBAR,
    payload: null,
});

export const hideRightSidebar = () => ({
    type: actionTypes.HIDE_RIGHT_SIDEBAR,
    payload: null,
});


export const initMenu = () => ({
    type: actionTypes.INIT_MENU,
    payload: {},
});

export const initMenuSuccess = (menuItems) => ({
    type: actionTypes.INIT_MENU_SUCCESS,
    payload: { menuItems },
});

export const changeActiveMenuFromLocation = () => ({
    type: actionTypes.CHANGE_ACTIVE_MENU_FROM_LOCATION,
    payload: {},
});

export const changeActiveMenuFromLocationSuccess = (activatedMenuItemId) => ({
    type: actionTypes.CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS,
    payload: activatedMenuItemId,
});